/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UserHasSeenProfileIdea$Params {

/**
 * ID of profile to which profil idea belongs
 */
  profileId: number;

/**
 * ID of profile idea which will be marked as seen
 */
  id: number;
}

export function userHasSeenProfileIdea(http: HttpClient, rootUrl: string, params: UserHasSeenProfileIdea$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, userHasSeenProfileIdea.PATH, 'post');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

userHasSeenProfileIdea.PATH = '/rest/profile/{profileId}/idea/{id}/seen';
